//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "parity-list",
  data(){
    return{
      wrapperHeight:0,
      allLoaded:false,
      config:{
        title:'比价单列表',
        url:'api/sourceComparePrice/page',
        workflowSearchBean:{},
        fixRules:{},
        inputCondition:{
          placeholder:'单号/名称',
          searchCondition:'key',
          rules:[{field: "code-title", option: "LIKE_ANYWHERE"}]
        },
      },
      list:[]
    }
  },
  methods:{
    getList(e,met,bol){
      this.$nextTick(()=>{
        if(bol){
          this.list = this.list.concat(e);
        }else{
          this.list = e;
        }
        if(met === 'top'){
          this.$refs.loadmore.onTopLoaded();
        }
        if(met === 'bottom'){
          this.$refs.loadmore.onBottomLoaded();
        }
      })
    },
    init: function() {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    loadTop(){
      this.$refs.header.getlist(true);
    },
    loadBottom(){
      this.$refs.header.getMore();
    },
    goDetail(item){
      this.$router.push(`/parity-detail/${item.id}`);
    }
  },
  mounted(){
    this.init();
    this.$refs.header.getlist();
  }
}



// WEBPACK FOOTER //
// ./src/page/sources/price-parity/parity-list.vue